import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import ThemeToggle from './ThemeToggle';

const Navbar = ({ toggle }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <motion.nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white dark:bg-gray-900 shadow-md py-4' : 'bg-secondary py-6'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container flex justify-between items-center">
        <div className="flex items-center">
          <h1 className="text-2xl font-bold">
            <span className="text-secondary dark:text-white"><img className="nav-logo" src={
                scrolled ? require('../assets/logo-big.png') : require('../assets/logo-big-w.png')
            }  alt="Aiabc 英语自主学习系统" /></span>
          </h1>
        </div>

        <div className="hidden lg:flex items-center space-x-8">
          <a href="#download" className={`font-bold ${scrolled ? 'text-gray-700 dark:text-white hover:text-secondary ' : 'text-white'} transition-colors`}>APP下载</a>
          <a href="#about" className={`font-bold ${scrolled ? 'text-gray-700 dark:text-white hover:text-secondary ' : 'text-white'} transition-colors`}>关于我们</a>
          <a href="#features" className={`font-bold ${scrolled ? 'text-gray-700 dark:text-white hover:text-secondary ' : 'text-white'} transition-colors`}>英语提分</a>
          {/*<a href="#services" className={`font-bold ${scrolled ? 'text-gray-700 dark:text-white hover:text-secondary ' : 'text-white'} transition-colors`}>服务</a>*/}
          {/*<a href="#pricing" className={`font-bold ${scrolled ? 'text-gray-700 dark:text-white hover:text-secondary ' : 'text-white'} transition-colors`}>价格</a>*/}
          <a href="#faq" className={`font-bold ${scrolled ? 'text-gray-700 dark:text-white hover:text-secondary ' : 'text-white'} transition-colors`}>常见问题</a>
          <a href="#support" className={`font-bold ${scrolled ? 'text-gray-700 dark:text-white hover:text-secondary ' : 'text-white'} transition-colors`}>技术支持</a>
        </div>

        <div className="flex items-center space-x-4">
          <ThemeToggle />

          <button
            className={`lg:hidden ${scrolled ? 'text-primary' : 'text-white'} dark:text-white`}
            onClick={toggle}
            aria-label="菜单"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
